import React, { useEffect } from "react";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import TopPageButton from "../Components/TopPage/TopePage";
import profilepic from "../Assets/profile-pic-2.jpg";
import CertificatePage from "../Components/Services/CertificatePage";
import { Helmet } from "react-helmet-async";
import ReactImage from "../Assets/Skills Icon/react.png";
import NodeImage from "../Assets/Skills Icon/node-js.png";
import ExpressImage from "../Assets/Skills Icon/express-js.png";
import JSImage from "../Assets/Skills Icon/javascript.png";
import MongoImage from "../Assets/Skills Icon/mongo-db.png";
import HtmlImage from "../Assets/Skills Icon/html-5.png";
import CSSImage from "../Assets/Skills Icon/css.png";
import GitImage from "../Assets/Skills Icon/github.png";
import GitBashImage from "../Assets/Skills Icon/gitbash.png";
import WordpressImage from "../Assets/Skills Icon/wordpress.png";
import WoocommerceImage from "../Assets/Skills Icon/woocommerce.png";
import FirebaseImage from "../Assets/Skills Icon/google-firebase.png";
import BootstrapImage from "../Assets/Skills Icon/bootstrap.png";
import MaterialImage from "../Assets/Skills Icon/material-ui.png";
import PhpImage from "../Assets/Skills Icon/php.png";
import myImage from "../Assets/Skills Icon/mysql.png";
import OfficeImage from "../Assets/Skills Icon/office.png";

const cardData = [
  {
    id: 1,
    image: ReactImage,
    title: "react",
  },
  {
    id: 2,
    image: NodeImage,
    title: "node",
  },
  {
    id: 3,
    image: ExpressImage,
    title: "express",
  },
  {
    id: 4,
    image: JSImage,
    title: "js",
  },
  {
    id: 5,
    image: MongoImage,
    title: "mongodb",
  },
  {
    id: 6,
    image: HtmlImage,
    title: "html",
  },
  {
    id: 7,
    image: CSSImage,
    title: "css",
  },
  {
    id: 8,
    image: BootstrapImage,
    title: "Bootstrap",
  },
  {
    id: 9,
    image: MaterialImage,
    title: "material-ui",
  },
  {
    id: 10,
    image: WordpressImage,
    title: "wordpress",
  },
  {
    id: 11,
    image: WoocommerceImage,
    title: "woocommerce",
  },
  {
    id: 12,
    image: FirebaseImage,
    title: "firebase",
  },
  {
    id: 13,
    image: PhpImage,
    title: "php",
  },
  {
    id: 14,
    image: myImage,
    title: "mysql",
  },
  {
    id: 15,
    image: OfficeImage,
    title: "office",
  },
  {
    id: 16,
    image: GitImage,
    title: "github",
  },
  {
    id: 17,
    image: GitBashImage,
    title: "gitbash",
  },
];

const About = () => {
  useEffect(() => {
    scroll.scrollToTop({ duration: 500 });
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>About | Aneeq Ullah Khan</title>
        <meta
          name="description"
          content="My name is Aneeq Ullah Khan, and I'm a MERN stack developer, Firebase and PHP developer.I studied at Aptech Pakistan, Jawan Pakistan and am currently pursuing a Bachelor's degree in Computer Science from Iqra University. Throughout my academic and professional career, I've honed my skills in full-stack web development, front-end development, and back-end development, among other areas."
        />
        <meta
          name="keywords"
          content="Aneeq Ullah Khan, Aneeq Ullah Khan About, About Aneeq Ullah Khan"
        />
      </Helmet>

      <Navbar />
      <div className="mainDiv">
        <p className="heading-text text-center">About Me</p>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 160">
          <path
            fill="#0d1117"
            fill-opacity="1"
            d="M0,64L80,80C160,96,320,128,480,128C640,128,800,96,960,85.3C1120,75,1280,85,1360,90.7L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </svg>
      </div>

      <div className="container mt-4 mb-4">
        <div className="row">
          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <h6>Hello !</h6>
            <p>
              My name is Aneeq Ullah Khan, and I'm a MERN stack developer,
              Firebase and PHP developer.I studied at Aptech Pakistan, Jawan
              Pakistan and am currently pursuing a Bachelor's degree in Computer
              Science from Iqra University. Throughout my academic and
              professional career, I've honed my skills in full-stack web
              development, front-end development, and back-end development,
              among other areas. Throughout my career, I have developed a strong
              understanding of the front-end development process, and I
              specialize in building modern web applications using the latest
              technologies and frameworks. I'm passionate about building
              high-quality, scalable, and efficient web applications that meet
              the needs of users and clients alike. I'm always on the lookout
              for new challenges and opportunities to learn and grow, and I'm
              committed to staying up-to-date with the latest technologies and
              best practices in my field. If you're interested in working with
              me or learning more about my skills and experience, please don't
              hesitate to reach out!
            </p>
          </div>
          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <div className="text-center">
              <img
                src={profilepic}
                alt=""
                style={{ height: "26rem", width: "26rem", borderRadius: "7%" }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-4 mb-5">
        <h6 className="section-text">Skills Set</h6>
        <p className="mb-3">
          My experience has allowed me to develop proficiency in working with
          various programming languages and frameworks, including Html5, Css3,
          JavaScript, React JS, React Native, Firebase, Express JS, Node JS,
          Bootstrap, Wordpress, Woocommerce, PHP, MongoDB, and MySQL.
        </p>
        <div className="row">
          {cardData.map((card, index) => (
            <div className="col-lg-2" key={index}>
              <img width="50" height="50" src={card.image} alt={card.title} />
              <br /> <br />
            </div>
          ))}
        </div>
      </div>

      <div className="container mt-4 mb-5">
        <h6 className="section-text">Certification Gallery</h6>
        <CertificatePage />
      </div>

      <Footer />
      <TopPageButton />
    </React.Fragment>
  );
};

export default About;
